module.exports = __webpack_public_path__ + "media/images/flags/pr-7845ecd77b3b58e3c8a531c23905ef9c.svg";